export const BLEED_INCHES = 0.125

// Fallback Cloud Render output resolution when a product has no Output DPI set
// in Sanity. The render pixelRatio is the target output DPI divided by the
// design's own DPI.
export const DEFAULT_OUTPUT_DPI = 600

// Matrix code zone: a 5mm reserved square. The only hard definition — consumers
// convert to px against the document's own px/inch at runtime.
export const MATRIX_CODE_MM = 5
